<template lang="pug">
  #ItemsListIndex.container-width
    b-card.rounded-0(
      bg-variant="light",
      v-for="(router,index) in routers",
      :key="index"
      v-if='router.isShow !== false'
    )
      router-link(
        :to="{name: router.routerPushName ? router.routerPushName : 'sa-items-list-index'}"
      )
        .row.no-gutters
          .col-2.pr-1.text-center
            //- Use Font Awesome Icon
            i.fa-lg(
              :class="router.iconClassName",
              style="font-size: 1.5rem;"
            )
          .col-10.pl-1
            span {{ router.name }}
</template>

<script>
import { SA_MSG_MANAGER_INDEX } from '@/router/sa/msg-manager';
import { SA_RESERVATION_INDEX } from '@/router/sa/reservation';
import { SA_CONTACTS_INDEX } from '@/router/sa/contacts';
import { SA_LABEL_INDEX } from '@/router/sa/label';
import { SA_PROFILE_INDEX } from '@/router/sa/profile';
import { SA_QR_CODE_INDEX } from '@/router/sa/qr-code';
import { SA_INVITATION_INDEX } from '@/router/sa/invitation';
import { SA_MEMBER_SEARCH_INDEX } from '@/router/sa/member-search';
import { SA_EVENT_ACTIVITY_INDEX } from '@/router/sa/event-activity';

export default {
  name: 'ItemsListIndex',
  data() {
    return {
      routers: [
        {
          name: '訊息管理',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_MSG_MANAGER_INDEX
        },
        {
          name: '我的預約',
          iconClassName: 'far fa-calendar-check',
          routerPushName: SA_RESERVATION_INDEX
        },
        {
          name: '顧客通訊錄',
          iconClassName: 'fas fa-users',
          routerPushName: SA_CONTACTS_INDEX
        },
        {
          name: '顧客標籤',
          iconClassName: 'fas fa-tag',
          routerPushName: SA_LABEL_INDEX
        },
        {
          name: 'QRcode',
          iconClassName: 'fas fa-qrcode',
          routerPushName: SA_QR_CODE_INDEX,
          isShow: true
        },
        {
          name: '修改個人資料',
          iconClassName: 'fas fa-edit',
          routerPushName: SA_PROFILE_INDEX
        },
        {
          name: '顧客查詢',
          iconClassName: 'fas fa-user',
          routerPushName: SA_MEMBER_SEARCH_INDEX
        },
        // {
        //   name: '邀請函',
        //   iconClassName: 'far fa-envelope',
        //   routerPushName: SA_INVITATION_INDEX,
        //   isShow: true
        // }
        {
          name: '活動預約',
          iconClassName: 'far fa-calendar-check',
          routerPushName: SA_EVENT_ACTIVITY_INDEX,
          isShow: process.env.VUE_APP_CAN_USE_EVENT_ACTIVITY === 'true'
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  }
};
</script>

<style>

</style>
